import { PromoCodeStatus } from 'store/models/promoCodes';

interface PromoCodeStatusFields {
    startDate: string | null;
    endDate: string | null;
    activationsLimit: number | null;
    activationsCount: number;
}

const getStartOfDay = (date: string | Date): Date => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
};

const getEndOfDay = (date: string | Date): Date => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
};

export const getPromoCodeStatus = (data: PromoCodeStatusFields): PromoCodeStatus => {
    const { startDate, endDate, activationsLimit, activationsCount } = data;
    const now = getStartOfDay(new Date());

    if (activationsLimit !== null && (activationsLimit === 0 || activationsCount >= activationsLimit)) {
        return PromoCodeStatus.Exhausted;
    }

    if (startDate && now < getStartOfDay(startDate)) {
        return PromoCodeStatus.Pending;
    }

    if (endDate && now > getEndOfDay(endDate)) {
        return PromoCodeStatus.Expired;
    }

    return PromoCodeStatus.Active;
};
